import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RowFocusBoxComponent } from './row-focus-box.component';


@NgModule({
  declarations: [RowFocusBoxComponent],
  imports: [
    CommonModule,
  ],
  exports:[RowFocusBoxComponent],
})
export class RowFocusBoxModule { }
